"use client";

import { useState } from "react";
import { Expand, X, ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type Photo = {
  id: number;
  src: string;
  srcset: string;
  sizes: string;
  alt: string;
  title: string;
  category: string;
  film: string;
  camera: string;
  year: string;
  span: string;
};
const filters = [{
  id: "all",
  label: "ALL OBSERVATIONS"
}, {
  id: "deep-sky",
  label: "DEEP-SKY & COSMOS"
}, {
  id: "solar-system",
  label: "SOLAR SYSTEM"
}];
const photos: Photo[] = [{
  id: 11,
  src: "https://cdn.astrobin.com/thumbs/nyuSVcbiiuvz_1824x0_Z-BERGNL.jpg?v=1781379108",
  srcset: "",
  sizes: "",
  alt: "M101, the Pinwheel Galaxy, a face-on grand design spiral in Ursa Major",
  title: "M101 · Solstice Salvage",
  category: "deep-sky",
  film: "BROADBAND OSC · 1H 35M",
  camera: "61EDPH III · ASI2600MC PRO",
  year: "2026",
  span: "row-span-2"
}, {
  id: 1,
  src: "https://cdn.astrobin.com/thumbs/vKp8FrMXYcPN_32768x0_b9muqi8S.jpg?v=1781019463",
  srcset: "",
  sizes: "",
  alt: "M13 globular cluster, the Great Hercules Cluster",
  title: "A Few Stars from M13",
  category: "deep-sky",
  film: "BROADBAND OSC · 2H 29M",
  camera: "61EDPH III · ASI2600MC PRO",
  year: "2026",
  span: "row-span-2"
}, {
  id: 2,
  src: "https://cdn.astrobin.com/thumbs/ezfkCmMDjL7l_16536x0_dMLKWf7g.jpg",
  srcset: "",
  sizes: "",
  alt: "Comet Lemmon C/2025 A6 at closest approach",
  title: "Comet Lemmon (C/2025 A6)",
  category: "solar-system",
  film: "BROADBAND OSC · 44M",
  camera: "150PDS · ASI2600MC PRO",
  year: "2025",
  span: "row-span-1"
}, {
  id: 3,
  src: "https://cdn.astrobin.com/thumbs/PcCpu2dxbhp2_16536x0_dMLKWf7g.jpg?v=1777683470",
  srcset: "",
  sizes: "",
  alt: "Western Veil Nebula captured under the Harvest Supermoon",
  title: "Western Veil Nebula",
  category: "deep-sky",
  film: "DUAL NARROWBAND · 1H 24M",
  camera: "150PDS · ASI2600MC PRO",
  year: "2025",
  span: "row-span-2"
}, {
  id: 4,
  src: "https://cdn.astrobin.com/thumbs/euUr1SgzwYg1_2560x0_esdlMP5Y.jpg?v=1777907562",
  srcset: "",
  sizes: "",
  alt: "The Cygnus Wall in the North America Nebula",
  title: "Cygnus Wall",
  category: "deep-sky",
  film: "DUAL NARROWBAND · 7H 20M",
  camera: "150PDS · ASI2600MC PRO",
  year: "2023",
  span: "row-span-1"
}, {
  id: 5,
  src: "https://cdn.astrobin.com/thumbs/0BjtZ7nYM7Cu_16536x0_ieTZ0INm.jpg?v=1777797160",
  srcset: "",
  sizes: "",
  alt: "SH2-199, the Soul Nebula",
  title: "SH2-199 · The Soul Nebula",
  category: "deep-sky",
  film: "DUAL NARROWBAND · 13H 45M",
  camera: "150PDS · ASI2600MC PRO",
  year: "2024",
  span: "row-span-2"
}, {
  id: 6,
  src: "https://cdn.astrobin.com/thumbs/s0gdYGpHMY0A_16536x0_ieTZ0INm.png?v=1777798864",
  srcset: "",
  sizes: "",
  alt: "NGC 281, the Pacman Nebula",
  title: "NGC 281 · The Pacman",
  category: "deep-sky",
  film: "DUAL NARROWBAND · 13H 25M",
  camera: "150PDS · ASI2600MC PRO",
  year: "2024",
  span: "row-span-1"
}, {
  id: 7,
  src: "https://cdn.astrobin.com/thumbs/cDYmVtl9WCig_16536x0_ieTZ0INm.png?v=1777735652",
  srcset: "",
  sizes: "",
  alt: "NGC 7380, the Wizard Nebula",
  title: "The Wizard Nebula",
  category: "deep-sky",
  film: "DUAL NARROWBAND · 9H 55M",
  camera: "150PDS · ASI2600MC PRO",
  year: "2024",
  span: "row-span-2"
}, {
  id: 8,
  src: "https://cdn.astrobin.com/thumbs/WLkOz9iK3CbI_16536x0_ieTZ0INm.jpg",
  srcset: "",
  sizes: "",
  alt: "Ionization fronts and dark globules in IC 1396A, the Elephant's Trunk Nebula, HOO palette",
  title: "IC 1396A · Elephant's Trunk",
  category: "deep-sky",
  film: "HOO PALETTE · 4H",
  camera: "150PDS · ASI2600MC PRO",
  year: "2024",
  span: "row-span-1"
}, {
  id: 9,
  src: "https://cdn.astrobin.com/thumbs/ClDLbz7Pqeku_16536x0_ieTZ0INm.png",
  srcset: "",
  sizes: "",
  alt: "M31, the Andromeda Galaxy — first year of imaging, before and after",
  title: "M31 · Andromeda",
  category: "deep-sky",
  film: "BROADBAND OSC · 18H 30M",
  camera: "150PDS · ASI2600MC PRO",
  year: "2023",
  span: "row-span-2"
}, {
  id: 10,
  src: "https://cdn.astrobin.com/thumbs/NnCvC8ruysHg_16536x0_7rIIWGbf.jpg",
  srcset: "",
  sizes: "",
  alt: "NGC 6992, the Eastern Veil Nebula",
  title: "Eastern Veil Nebula",
  category: "deep-sky",
  film: "DUAL NARROWBAND · 10H",
  camera: "150PDS · ASI2600MC PRO",
  year: "2023",
  span: "row-span-1"
}];
function PhotoTile({
  photo,
  index,
  onOpen
}: {
  photo: Photo;
  index: number;
  onOpen: (p: Photo) => void;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <div data-index={index} ref={ref} className={`group relative overflow-hidden rounded-md border border-border/20 cursor-pointer break-inside-avoid mb-4 transition-all duration-700 ease-out ${isVisible ? "opacity-100 blur-0" : "opacity-0 blur-md"}`} onClick={() => onOpen(photo)}>
      <img src={photo.src} data-wvc-srcset={photo.srcset} data-wvc-sizes={photo.sizes} alt={photo.alt} loading="lazy" decoding="async" className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-[1.03]" />

      <div className="absolute top-3 right-3 size-8 rounded-md bg-background/40 backdrop-blur-md flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 border border-white/10">
        <Expand className="size-4 text-foreground" />
      </div>

      <div className={`absolute inset-0 bg-gradient-to-t ${photo.category === 'solar' ? 'from-destructive/40' : 'from-secondary/40'} via-background/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500`} />

      <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-3 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-500">
        <h3 className="font-default text-xl text-foreground mb-1.5 leading-tight font-semibold">
          {photo.title}
        </h3>
        <p className="font-mono text-[10px] tracking-widest uppercase text-foreground/90">
          {photo.film} · {photo.camera} · {photo.year}
        </p>
      </div>
    </div>;
}
export default function TheSolarCore() {
  const [activeFilter, setActiveFilter] = useState("all");
  const [selectedPhoto, setSelectedPhoto] = useState<Photo | null>(null);
  const filtered = activeFilter === "all" ? photos : photos.filter(p => p.category === activeFilter);
  const currentIndex = selectedPhoto ? filtered.findIndex(p => p.id === selectedPhoto.id) : -1;
  const handlePrev = () => {
    if (currentIndex > 0) setSelectedPhoto(filtered[currentIndex - 1]);else setSelectedPhoto(filtered[filtered.length - 1]);
  };
  const handleNext = () => {
    if (currentIndex < filtered.length - 1) setSelectedPhoto(filtered[currentIndex + 1]);else setSelectedPhoto(filtered[0]);
  };
  return <section data-section-id="2432" id="the-solar-core" className="bg-background text-foreground py-16 lg:py-24">
      <div className="px-6 lg:pl-24 lg:pr-12 mb-12 lg:mb-16">
        <div className="text-center mb-10">
          <p className="font-mono text-xs tracking-[0.3em] text-accent-foreground uppercase">
            50° 16&apos; N · OBSERVATION LOG · 2022—2026
          </p>
        </div>

        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 pb-8 border-b border-border/20">
          <h2 className="font-default text-3xl md:text-4xl lg:text-[40px] leading-tight text-foreground max-w-xl font-bold">
            Dual-Core Gallery <span className="text-muted-foreground italic font-light">/ solar & deep-sky.</span>
          </h2>

          <div className="flex flex-wrap gap-2">
            {filters.map((filter, i) => <Button key={filter.id} data-index={i} variant="ghost" size="sm" onClick={() => setActiveFilter(filter.id)} className={`rounded-md px-4 h-8 font-mono text-[10px] tracking-widest uppercase border transition-all ${activeFilter === filter.id ? "bg-foreground text-background border-foreground hover:bg-foreground hover:text-background" : "bg-transparent text-muted-foreground border-border/40 hover:bg-accent hover:text-accent-foreground"}`}>
                {filter.label}
              </Button>)}
          </div>
        </div>
      </div>

      <div className="px-6 lg:pl-24 lg:pr-12">
        <div className="columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-4">
          {filtered.map((photo, i) => <PhotoTile key={photo.id} photo={photo} index={i} onOpen={setSelectedPhoto} />)}
        </div>
      </div>

      <div className="flex flex-col items-center mt-16 gap-3">
        <Button size="lg" className="rounded-md bg-foreground text-background hover:bg-foreground/90 font-mono text-xs tracking-[0.25em] uppercase h-12 px-10 transition-transform hover:scale-[1.02]">
          Access Archive
        </Button>
        <p className="font-mono text-[10px] tracking-widest text-muted-foreground">
          BORTLE 5 SKIES · VERNON, BC · DATA STREAM ACTIVE
        </p>
      </div>

      <Dialog open={!!selectedPhoto} onOpenChange={open => !open && setSelectedPhoto(null)}>
        <DialogContent showCloseButton={false} className="max-w-[95vw] sm:max-w-[95vw] w-[95vw] h-[92vh] p-0 bg-background border-border/30 overflow-hidden rounded-md">
          {selectedPhoto && <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] h-full overflow-y-auto lg:overflow-hidden">
              <div className="relative flex items-center justify-center bg-card overflow-hidden">
                <img src={selectedPhoto.src} data-wvc-srcset={selectedPhoto.srcset} data-wvc-sizes={selectedPhoto.sizes} alt={selectedPhoto.alt} className="max-w-full max-h-[75vh] lg:max-h-full object-contain" />

                <Button variant="ghost" size="icon" onClick={handlePrev} className="absolute left-4 top-1/2 -translate-y-1/2 size-11 rounded-md bg-background/60 backdrop-blur-md hover:bg-background/80 text-foreground border border-white/10">
                  <ChevronLeft className="size-5" />
                </Button>

                <Button variant="ghost" size="icon" onClick={handleNext} className="absolute right-4 top-1/2 -translate-y-1/2 size-11 rounded-md bg-background/60 backdrop-blur-md hover:bg-background/80 text-foreground border border-white/10">
                  <ChevronRight className="size-5" />
                </Button>

                <Button variant="ghost" size="icon" onClick={() => setSelectedPhoto(null)} className="absolute top-4 right-4 size-10 rounded-md bg-background/60 backdrop-blur-md hover:bg-background/80 text-foreground lg:hidden border border-white/10">
                  <X className="size-5" />
                </Button>
              </div>

              <div className="relative p-8 lg:p-10 flex flex-col gap-8 bg-background border-t lg:border-t-0 lg:border-l border-border/30 overflow-y-auto">
                <Button variant="ghost" size="icon" onClick={() => setSelectedPhoto(null)} className="absolute top-4 right-4 size-9 rounded-md hover:bg-accent text-foreground hidden lg:flex">
                  <X className="size-4" />
                </Button>

                <div>
                  <p className={`font-mono text-[10px] tracking-[0.3em] ${selectedPhoto.category === 'solar' ? 'text-destructive' : 'text-secondary'} uppercase mb-3`}>
                    {selectedPhoto.category}
                  </p>
                  <h3 className="font-default text-3xl text-foreground leading-tight mb-2 font-bold">
                    {selectedPhoto.title}
                  </h3>
                  <p className="font-mono text-[10px] tracking-widest text-muted-foreground uppercase">
                    Observation {String(currentIndex + 1).padStart(3, "0")} / {String(filtered.length).padStart(3, "0")}
                  </p>
                </div>

                <div className="space-y-5 pt-6 border-t border-border/20">
                  <div>
                    <p className="font-mono text-[10px] tracking-widest text-muted-foreground uppercase mb-1.5">
                      Spectral Band
                    </p>
                    <p className="font-default text-base text-foreground font-medium">{selectedPhoto.film}</p>
                  </div>
                  <div>
                    <p className="font-mono text-[10px] tracking-widest text-muted-foreground uppercase mb-1.5">
                      Optical System
                    </p>
                    <p className="font-default text-base text-foreground font-medium">{selectedPhoto.camera}</p>
                  </div>
                  <div>
                    <p className="font-mono text-[10px] tracking-widest text-muted-foreground uppercase mb-1.5">
                      Epoch
                    </p>
                    <p className="font-default text-base text-foreground font-medium">{selectedPhoto.year}</p>
                  </div>
                  <div>
                    <p className="font-mono text-[10px] tracking-widest text-muted-foreground uppercase mb-1.5">
                      Processing
                    </p>
                    <p className="font-default text-base text-foreground font-medium">PixInsight · RC Astro Suite</p>
                  </div>
                </div>

                <div className="mt-auto pt-6 border-t border-border/20">
                  <p className="font-mono text-[10px] tracking-widest text-muted-foreground uppercase leading-relaxed">
                    All observations captured and processed in-house from Bortle 5 skies. Full acquisition details available on AstroBin (@dolphyking).
                  </p>
                </div>
              </div>
            </div>}
        </DialogContent>
      </Dialog>
    </section>;
}